"use client";

import { useCallback, useEffect, useState } from "react";

import {
  acceptAllConsent,
  readCookieConsent,
  rejectOptionalConsent,
  writeCookieConsent,
  type CookieConsent as CookieConsentValue,
  type CookieConsentCategory
} from "@/shared/utils/cookieConsent";

import { CookieBanner } from "./cookie-banner";
import { CookieSettingsDialog } from "./cookie-settings-dialog";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [draft, setDraft] = useState<CookieConsentValue>(rejectOptionalConsent);

  useEffect(() => {
    setIsVisible(!readCookieConsent());
  }, []);

  const submit = useCallback((consent: CookieConsentValue) => {
    writeCookieConsent(consent);
    setIsSettingsOpen(false);
    setIsVisible(false);
  }, []);

  const rejectOptional = useCallback(
    () => submit(rejectOptionalConsent()),
    [submit]
  );

  const changeCategory = useCallback(
    (category: CookieConsentCategory, checked: boolean) =>
      setDraft((consent) => ({ ...consent, [category]: checked })),
    []
  );

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {!isSettingsOpen && (
        <CookieBanner
          onAcceptAll={() => submit(acceptAllConsent())}
          onRejectOptional={rejectOptional}
          onCustomize={() => {
            setDraft(rejectOptionalConsent());
            setIsSettingsOpen(true);
          }}
        />
      )}
      <CookieSettingsDialog
        open={isSettingsOpen}
        consent={draft}
        onOpenChange={setIsSettingsOpen}
        onCategoryChange={changeCategory}
        onSave={() => submit(draft)}
        onRejectOptional={rejectOptional}
      />
    </>
  );
};
